// extracted by mini-css-extract-plugin
module.exports = {"container":"ListPromotions_container__1PQuL cy-6","list":"ListPromotions_list__1ROzP list-reset"};